import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    maxWidth: '800px',
    margin: '0 auto',

    [theme.breakpoints.down('sm')]: {
      padding: '16px 0 80px'
    }
  },
  description: {
    marginTop: '20px',
    fontSize: '16px',
    lineHeight: 1.6,
    color: '#2E2E2E',

    '& h3': {
      fontSize: '16px',
      fontWeight: 700,
      color: '#2E2E2E',
      marginTop: '16px',
      marginBottom: '4px'
    },
    '& ul, & ol': {
      paddingLeft: '20px',
      marginTop: '0',
      marginBottom: '8px'
    },
    '& li': {
      marginBottom: '4px'
    },
    '& p': {
      marginBottom: '8px'
    },
    '& strong': {
      fontWeight: 700
    }
  },
  applySection: {
    marginTop: '32px'
  },
  applyBox: {
    width: '100%',
    background: theme.palette.background.paper,
    borderRadius: '24px',
    padding: '26px 24px',
    marginTop: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  applyText: {
    textAlign: 'center',
    fontSize: '18px',
    color: '#111111',

    [theme.breakpoints.down('sm')]: {
      fontSize: '16px'
    }
  },
  notFoundContainer: {
    minHeight: '70vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}))
